import {
    Modal,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    Checkbox,
} from "react-bootstrap";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

const strings = {
    posTenderName: "POS Tender Name",
    splitTender: "Split Tender",
    accountingName1: "Accounting Name",
    accountingName2: "Accounting Name - 2",
    split: "Split %",
    accountName: "Account Name",
    save: "Save",
    cancel: "Cancel",
};

export default class ExternalTenderModal extends PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        tenderName: PropTypes.string.isRequired,
        accounts: PropTypes.array.isRequired,
        handleClose: PropTypes.func.isRequired,
        handleSave: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
    };

    state = {
        tenderName: this.props.tenderName,
        splitTender: this.props.accounts.length > 1,
        accountName1: this.props.accounts.length > 0 ? this.props.accounts[0].name : "",
        split1: this.props.accounts.length > 1 ? this.props.accounts[0].percentage : 100,
        accountName2:  this.props.accounts.length > 1 ? this.props.accounts[1].name : "",
        split2: this.props.accounts.length > 1 ? this.props.accounts[1].percentage : 0,
    };

    _onSave = () => this.props.handleSave(this.state.tenderName, this.state.splitTender, this.state.accountName1, this.state.split1, this.state.accountName2, this.state.split2)

    _onTenderNameChange = e => {
        this.setState({ tenderName: e.target.value });
    };

    _onSplitTenderChange = () => {
        this.setState({ splitTender: !this.state.splitTender })
    }

    _onAccountName1Change = e => {
        this.setState({ accountName1: e.target.value });
    };

    _onSplit1Change = e => {
        this.setState({ split1: e.target.value });
    };

    _onAccountName2Change = e => {
        this.setState({ accountName2: e.target.value });
    };

    _onSplit2Change = e => {
        this.setState({ split2: e.target.value });
    };

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup controlId="tenderName">
                        <ControlLabel>{strings.posTenderName}</ControlLabel>
                        <FormControl
                                id="tenderName"
                                value={this.state.tenderName}
                                onChange={this._onTenderNameChange}
                                disabled={this.props.loading}
                        />
                    </FormGroup>
                    <FormGroup controlId="splitTender">
                        <Checkbox
                            id="splitTender"
                            checked={this.state.splitTender}
                            onChange={this._onSplitTenderChange}
                             disabled={this.props.loading}
                        >
                            {strings.splitTender}
                        </Checkbox>
                    </FormGroup>
                    <FormGroup controlId="accountName1">
                        <ControlLabel>{strings.accountingName1}</ControlLabel>
                        <FormControl
                            id="accountName1"
                            value={this.state.accountName1}
                            onChange={this._onAccountName1Change}
                            disabled={this.props.loading}
                        />
                    </FormGroup>
                    {this.state.splitTender && (
                        <>
                            <FormGroup controlId="split1">
                                <ControlLabel>{strings.split}</ControlLabel>
                                <FormControl
                                    id="split1"
                                    type="number"
                                    min="0"
                                    value={this.state.split1}
                                    onChange={this._onSplit1Change}
                                    disabled={this.props.loading}
                                />
                            </FormGroup>
                            <FormGroup controlId="accountName2">
                                <ControlLabel>{strings.accountingName2}</ControlLabel>
                                <FormControl
                                    id="accountName2"
                                    value={this.state.accountName2}
                                    onChange={this._onAccountName2Change}
                                    disabled={this.props.loading}
                                />
                            </FormGroup>
                            <FormGroup controlId="split2">
                                <ControlLabel>{strings.split}</ControlLabel>
                                <FormControl
                                    id="split2"
                                    type="number"
                                    min="0"
                                    value={this.state.split2}
                                    onChange={this._onSplit2Change}
                                    disabled={this.props.loading}
                                />
                            </FormGroup>
                        </>)}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.handleClose} disabled={this.props.loading}>{strings.cancel}</Button>
                    <Button onClick={this._onSave} bsStyle="primary" disabled={this.props.loading}>
                        {strings.save}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
